import React from "react";

const Staffing = () => (
  <section className="mk-section" id="staffing" data-testid="section-staffing">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2 className="mk-outline-title">Passez plus de temps auprès de vos clients et collaborateurs</h2>
        </div>
      </div>
      <div className="mk-challenge mk-reveal">
        <article className="mk-problem">
          <span className="mk-tag">sans ASAP Hub</span>
          <h3>Trop de temps perdu sur des tâches administratives et de coordination.</h3>
          <div className="mk-checklist">
            <div className="mk-check"><i aria-hidden="true" /><span>Données dispersées dans plusieurs outils.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Suivi du staffing manuel et chronophage.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Le matching profils/besoins est aléatoire.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Vue d'ensemble difficile à reconstituer.</span></div>
          </div>
        </article>
        <article className="mk-solution">
          <span className="mk-tag">Avec ASAP Hub</span>
          <h3>ASAP Hub centralise, matche et fluidifie la collaboration.</h3>
          <div className="mk-checklist">
            <div className="mk-check"><i aria-hidden="true" /><span>Une vue unique sur consultants, clients et besoins.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Matching automatique profils/besoins.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Suivi des performances et KPIs en temps réel.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Plus de temps pour la valeur ajoutée client.</span></div>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default Staffing;
